import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFoundIllustration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9401 42.356C12.4269 39.4355 12.6703 37.9753 13.3868 36.8723C14.0604 35.8355 15.0237 35.0195 16.1572 34.5255C17.3629 34 18.8433 34 21.8041 34H38.1949C41.1557 34 42.636 34 43.8418 34.5255C44.9752 35.0195 45.9385 35.8355 46.6121 36.8723C47.3287 37.9753 47.5721 39.4355 48.0588 42.356C48.7156 46.2967 49.044 48.2671 48.4944 49.8088C47.9798 51.2524 46.9573 52.4595 45.6178 53.2045C44.1875 54 42.1899 54 38.1949 54H21.8041C17.809 54 15.8115 54 14.3811 53.2045C13.0417 52.4595 12.0192 51.2524 11.5045 49.8088C10.955 48.2671 11.2834 46.2967 11.9401 42.356Z",
			fill: "url(#paint0_linear_1936_54433)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 8.36684,
			y: -1.63316,
			width: 42.2663,
			height: 53.2663,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.32px)",
					clipPath: "url(#bgblur_0_1936_54433_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 6.63316,
			d: "M29.5 5.5C37.2089 5.5 43.5 12.075 43.5 20.2383C43.5 24.3492 41.9048 30.4619 39.3076 35.5479C38.011 38.0869 36.4789 40.3407 34.7979 41.9531C33.1143 43.568 31.3247 44.5 29.5 44.5C27.6753 44.5 25.8857 43.568 24.2021 41.9531C22.5211 40.3407 20.989 38.0869 19.6924 35.5479C17.0952 30.4619 15.5 24.3492 15.5 20.2383C15.5 12.075 21.7911 5.5 29.5 5.5Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_1936_54433)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 8.36684,
			y: -1.63316,
			width: 42.2663,
			height: 53.2663,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.68px)",
					clipPath: "url(#bgblur_1_1936_54433_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-figma-bg-blur-radius": 7.35296,
			cx: 29.5,
			cy: 19.5,
			r: 5,
			fill: "url(#paint2_linear_1936_54433)",
			stroke: "url(#paint3_linear_1936_54433)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_1936_54433_clip_path",
				transform: "translate(-8.36684 1.63316)",
				children: /* @__PURE__ */ _jsx("path", { d: "M29.5 5.5C37.2089 5.5 43.5 12.075 43.5 20.2383C43.5 24.3492 41.9048 30.4619 39.3076 35.5479C38.011 38.0869 36.4789 40.3407 34.7979 41.9531C33.1143 43.568 31.3247 44.5 29.5 44.5C27.6753 44.5 25.8857 43.568 24.2021 41.9531C22.5211 40.3407 20.989 38.0869 19.6924 35.5479C17.0952 30.4619 15.5 24.3492 15.5 20.2383C15.5 12.075 21.7911 5.5 29.5 5.5Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_1936_54433_clip_path",
				transform: "translate(-8.36684 1.63316)",
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 29.5,
					cy: 19.5,
					r: 5
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1936_54433",
				x1: 50,
				y1: 44,
				x2: 10,
				y2: 44,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1936_54433",
				x1: 13.55,
				y1: 7.85714,
				x2: 44.9345,
				y2: 42.6084,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1936_54433",
				x1: 25.1921,
				y1: 24.8849,
				x2: 25.58,
				y2: 12.9892,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_1936_54433",
				x1: 2.12923,
				y1: 28.7211,
				x2: 3.73208,
				y2: 8.2591,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNotFoundIllustration);
export { ForwardRef as ReactComponent };
